// extracted by mini-css-extract-plugin
export default {"title":"header-content_title__dsyh4","badge":"header-content_badge__crJIo"};